/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ShivaWebSecuredConfiguration configuration object with a given root URL.
 */
export function provideShivaWebSecuredConfiguration(rootUrl: string) {
  var config = new ShivaWebSecuredConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ShivaWebSecuredConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaWebSecuredConfiguration {
  rootUrl: string = 'http://localhost:8090/web';
}

